export default Object.freeze({
  FONT_SIZE_CONTROLS: 'fontSizeControls',
  CONTRAST_CONTROL: 'contrastControl',
});
